import React from 'react'
import { Link } from 'react-router-dom'
import Footer from './components/Footer'

function Ja() {


  return (
    <div>
        <div className='takk-heading'>
            <div></div>
        </div>
        <div className='takk-body'>
            <h1><strong>Takk!</strong></h1>
            <p>Dere er nå registrert for å motta kort og relevant informasjon om kunstgress, granulatsvinn og aktuelle støtte- og tiltaksmuligheter.</p>
            <p>Vi sender kun informasjon som er relevant for klubber, og ikke oftere enn nødvendig.</p>
            <p>Skulle det ikke være aktuelt lenger, kan dere når som helst si ifra eller melde dere av.</p>
            <p>Ha en fin dag videre!</p>
            <br></br>
            <Link className='takk-knapp' to="/">
                Hjem
            </Link>
        </div>

        <Footer />
    </div>
  )
}

export default Ja